import React, { useState, useEffect, Suspense } from "react";
import { PrismicRichText } from "@prismicio/react";
import ScriptInjector from "../script-injector";

// Dynamic import for Lottie to avoid SSR issues
const Lottie = React.lazy(() => import("lottie-react"));

export const LottieSideSide = (props) => {
  const sc = props.slice.primary;

  let space = sc.spacing;
  if (space === "Both large") space = "gutter";
  else if (space === "Both small") space = "gutter sm";
  else if (space === "Top large") space = "gutter bot";
  else if (space === "Top small") space = "gutter bot sm";
  else if (space === "Bottom large") space = "gutter top";
  else space = "gutter top sm";

  let bg =
    sc.background === "gradient"
      ? "gradient-to-b from-grey-light to-white"
      : sc.background === "grey"
      ? "grey-light"
      : sc.background === "dark grey"
      ? "grey-d"
      : sc.background;

  // Parse JSON only on client side
  const [lotty1, setLotty1] = useState(null);
  const [lotty2, setLotty2] = useState(null);

  useEffect(() => {
    // Parse JSON only in browser
    if (typeof window !== 'undefined') {
      try {
        setLotty1(JSON.parse(sc.lottie_json_1));
        setLotty2(JSON.parse(sc.lottie_json_2));
      } catch (error) {
        console.error('Error parsing Lottie JSON:', error);
      }
    }
  }, [sc.lottie_json_1, sc.lottie_json_2]);

  const lightBG = ["gradient", "grey", "white"].includes(sc.background) ? sc.background : null;
  const textCheck = lightBG != null ? "text-grey" : "text-white";

  return (
    <section className={"lottie bg-" + bg + " " + " " + space}>
      <div className="wrapper inner">
      <div className={"text-left md:text-center mb-12 " + textCheck}>
      <PrismicRichText field={sc.section_title.richText} />
        <PrismicRichText field={sc.section_content.richText} /></div>
        <div className="flex flex-col md:flex-row justify-between">
          <div className="w-full md:w-1/2" id="lottie-container">
            <div>
              {typeof window !== 'undefined' && lotty1 ? (
                <Suspense fallback={<div>Loading animation...</div>}>
                  <Lottie
                    animationData={lotty1}
                    aria-labelledby="use lottie animation"
                    loop={false}
                    autoPlay={false}
                  />
                </Suspense>
              ) : (
                <div>Loading animation...</div>
              )}
            </div>
          </div>
          <div className="w-full md:w-1/2">
            <div>
              {typeof window !== 'undefined' && lotty2 ? (
                <Suspense fallback={<div>Loading animation...</div>}>
                  <Lottie
                    animationData={lotty2}
                    aria-labelledby="use lottie animation"
                    loop={false}
                    autoPlay={false}
                  />
                </Suspense>
              ) : (
                <div>Loading animation...</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <ScriptInjector html={sc.custom_html} />
    </section>
  );
};
